export enum EUserType {
    ADMIN = 1,
    SELLER = 2,
    CUSTOMER = 3,
    PRODUCTION = 4,
    FINANCE = 5,
    CARRIER = 6,
    SUPPLIER = 7,
    BUYER = 8,
    SUPPLIER_CONTACT = 9,
}
